import React from 'react';
import PropTypes from 'prop-types';
import YodleeLinkModal from 'Components/Modals/AccountAggregator/yodleeLinkModal';
import FinicityModal from 'Components/Modals/AccountAggregator';

const AggregatorModalPicker = ({
  source, resource, onClose, aggregatorLink, onComplete, onSyncStarted,
}) => {
  switch (source) {
    case 'yodlee':
      return (
        <YodleeLinkModal
          institutionResource={resource}
          yodleeConfigLink={aggregatorLink}
          onClose={onClose}
          onComplete={onComplete}
          onSyncStarted={onSyncStarted}
        />
      );
    case 'finicity':
      return (
        <FinicityModal
          finicityLink={aggregatorLink}
          onClose={onClose}
          onComplete={onComplete}
          onSyncStarted={onSyncStarted}
        />
      );
      // plaid has its own modal. we dont need to handle it
    default:
      return null;
  }
};

AggregatorModalPicker.defaultProps = {
  className: '',
};

AggregatorModalPicker.propTypes = {
  className: PropTypes.string,
};

export default AggregatorModalPicker;
